import type { HRAuthContextType } from 'src/auth/types';

import { createContext } from 'react';

export const HRAuthContext = createContext<HRAuthContextType | undefined>(undefined);